import React from 'react';
import style from './NextEarnings.module.css';

const EarningsSection = ({ data, title, dateLabel }) => {
  if (!data) return null;

  const formatNumber = (num) => {
    if (num == null || num === 0) return '-';
    if (num >= 1000000000) return '$' + (num / 1000000000).toFixed(2) + ' B';
    if (num >= 1000000) return '$' + (num / 1000000).toFixed(2) + ' M';
    return '$' + num.toLocaleString();
  };

  const formatTime = (time) => {
    if (!time) return null;
    const t = time.toLowerCase();
    if (t === 'bmo') return 'Before Market';
    if (t === 'amc') return 'After Market';
    return time;
  };

  return (
    <div className={style.container}>
      <h3 className={style.headline}>{title}</h3>
      <div className={style.content}>
        <div className={style.dateSection}>
          <span className={style.label}>{dateLabel}</span>
          <div className={style.dateValue}>
            {formatCalendarDate(data.date)}
          </div>
          {data.time && (
            <div className={style.timeBadge}>{formatTime(data.time)}</div>
          )}
        </div>

        <div className={style.metricsSection}>
          <div className={style.metric}>
            <span className={style.label}>EPS Estimate</span>
            <div className={style.value}>
              {data.eps_estimated != null ? `$${data.eps_estimated.toFixed(2)}` : '-'}
            </div>
            <span className={style.subLabel}>Consensus analyst estimate</span>
          </div>

          <div className={style.metric}>
            <span className={style.label}>Revenue Estimate</span>
            <div className={style.value}>
              {formatNumber(data.revenue_estimated)}
            </div>
            <span className={style.subLabel}>Consensus analyst estimate</span>
          </div>
        </div>
      </div>
    </div>
  );
};

function formatCalendarDate(value) {
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return '';

  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}

const NextEarnings = ({ next_earnings, last_earnings }) => {
  if (!next_earnings && !last_earnings) return null;

  return (
    <div className={style.wrapper}>
      <EarningsSection
        data={last_earnings}
        title="Last Earnings Call"
        dateLabel="Report Date"
      />
      <EarningsSection
        data={next_earnings}
        title="Next Earnings Call"
        dateLabel="Expected Date"
      />
    </div>
  );
};

export default NextEarnings;

